import { redirectTo } from '../js/utils/redirectUtils.js';
import { CounterComponent } from '../js/components/CounterComponent.js';
import { ConversionsModalsComponent } from '../js/components/ConversionsModalsComponent.js';
import { NavigationPaneComponent } from '../js/components/NavigationPaneComponent.js';
import { getRequest } from '../js/utils/fetchUtils.js';
import { setCookie, checkCookie } from '../js/utils/cookieUtils.js';
import { formatDateForData } from '../js/utils/dateFormatUtils.js';
import { validateEmailField, okClickSingIn, toggleFieldsValidation, clearTextContent, isFormValid, getFormValues, startEmailValidationProcess, checkforEmptyFields } from '../js/components/authenticationValidation.js';
import CONSTANTS from '../js/constants/constants.js';


//TODO: do not use jquery -> Vanilla JavaScript
const $fileWrapper = $('.files');
const $fileInput = $('.js-input-files');
const $inputtedFilesPlacement = $('.js-show-inputted-files');
const $inputtedFileWrapper = $('.inputted-files');
const $convertButton = $('.js-convert-files-button');
const $clearInputtedFilesBtn = $('.js-clear-inputted-files');
const $inputLimit = $('.js-input-limit');
const $accountButton = $('.account-actions__button');
const $accountMenu = $('.account-actions__menu');
const convertNewFilesBtn = document.querySelector('.js-convert-new-files');
const navigateHomeBtn = document.querySelector('.js-home-navigation');
const downloadConvertedFilesBtn = document.querySelector('.js-download-converted-files');
const contactBtns = document.querySelectorAll('.js-contact-btn');
const userInfoFormElem = document.getElementById("user-info-form");
const cookiesModal = document.querySelector('#cookiesModal');
const closeCookiesModalBtn = document.querySelector('#closeCookiesModalBtn');

let isError = false;
let isLargeFile = false;
let inputtedFiles, converterResponse;
let pendingPageRefreshAfterSuccessSignin = false;
let accountMenuVisibility = false;
let isLimit = false;

export let counterComponent, currentPlanInfo, conversionsModalsComponent, navigationPaneComponent;

//Event listeners

//Navigation
navigateHomeBtn.addEventListener('click', prepareConvertNewFiles);

//Convertion of files
$fileInput.on('change', handleFileInputChange);
$convertButton.on('click', handleConvertButtonClick);
$clearInputtedFilesBtn.on('click', clearInputtedFiles);
$accountButton.on('click', handleAccountBtnClick);

//Fix for buttons. TODO: use only where buttons are needed, not globally
if (convertNewFilesBtn) {
    convertNewFilesBtn.addEventListener('click', handleConvertNewFiles);
}
if (downloadConvertedFilesBtn) {
    downloadConvertedFilesBtn.addEventListener('click', () => {
        if (inputtedFiles) {
            convertFiles(inputtedFiles);
        }
    });
}
if (contactBtns) {
    contactBtns.forEach(btn => {
        btn.addEventListener('click', handleContactBtnClick); // Add event listener to each button
    });
}

//Cookies
closeCookiesModalBtn.addEventListener('click', handleCookieModalCloseBtnClick, false);

//Event Listeners Functions
function handleFileInputChange(event) {
    inputAlertShow(false);
    isError = false;
    isLargeFile = false;
    let inputedFilesSize;
    inputtedFiles = event.target.files;
    for (let i = 0; i < inputtedFiles.length; i++) {
        if (i === 0) {
            inputedFilesSize = inputtedFiles[i].size;
        } else {
            inputedFilesSize += inputtedFiles[i].size;
        }

        if (inputtedFiles[i].size > CONSTANTS.ONE_FILE_SIZE_LIMIT) {
            isLargeFile = true;
        }

    }
    const limits = [
        {
            name: "size",
            value: inputedFilesSize,
            limit: CONSTANTS.TOTAL_UPLOAD_SIZE_LIMIT,
            errorText: "The maximum total upload size is 20 MB."
        },
        {
            name: "count",
            value: inputtedFiles.length,
            limit: CONSTANTS.TOTAL_UPLOAD_COUNT_LIMIT,
            errorText: "You can attach a maximum of 20 files."
        }
    ];

    for (let i = 0; i < limits.length; i++) {
        if (limits[i].value > limits[i].limit) {
            $inputLimit.append(`<div><i class="fa-solid fa-triangle-exclamation"></i> ${limits[i].errorText}</div>`)
            isError = true;
            inputAlertShow(true);
        }
    };

    if (isLargeFile) {
        $inputLimit.append(`<div><i class="fa-solid fa-triangle-exclamation"></i> The maximum individual file size is 1 MB.</div>`);
        isError = true;
        inputAlertShow(true);
    }

    if (!isError) {
        if (inputtedFiles.length > 0) {
            $convertButton.prop('disabled', false);
            showInputedFiles(inputtedFiles);
            $clearInputtedFilesBtn.removeClass('d-none');
            $inputtedFileWrapper.removeClass('d-none');
            $('.decoration').addClass('d-none');

        } else {
            clearInputtedFiles();
            $convertButton.prop('disabled', true);
        }
    }
};

function handleConvertButtonClick() {
    convertFiles(inputtedFiles);
    convertInProgress();
};

function handleConvertNewFiles() {
    if (pendingPageRefreshAfterSuccessSignin) {
        reloadPage();
    }
    else {
        prepareConvertNewFiles();
    }
};

function handleContactBtnClick() {
    redirectTo(CONSTANTS.CONTACT_URL, '_blank');
};

function handleCookieModalCloseBtnClick(e) {
    cookiesModal.style.display = 'none';
    setCookie("WalrusDenegeratorAllowCookies", 'true', 365);
};

function handleAccountBtnClick(e) {
    e.stopPropagation();
    if ($accountMenu.hasClass('account-actions--collapsed')) {
        $accountMenu.removeClass('account-actions--collapsed');
        accountMenuVisibility = false;
    } else {
        $accountMenu.addClass('account-actions--collapsed')
        accountMenuVisibility = true;
    }
};

if (userInfoFormElem) {
    userInfoFormElem.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();
            const button = document.querySelector('.js-signin-button');
            button.click();
        }
    });
}

//Fixes
$('a').attr('tabindex', '-1'); //Fix

$(document).click(function (e) {

    if (!$(e.target).is($accountButton) && !$(e.target).is($accountMenu)) {
        $accountMenu.addClass('account-actions--collapsed');
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const loginContainerFix = document.querySelector('#loginContainer');
    if (loginContainerFix) {
        configureSignIn("#loginContainer", signInPopupsData.signIn, function () {
            var url = new URLSearchParams(window.location.search).get('ReturnUrl') ?? "/";
            location.href = url;
        });
    }
});

//Functions

function renderCopyrightDate() {
    const currentYear = new Date().getFullYear();
    $('.js-copyright-years').html('2023 − ' + currentYear);
}

async function rerenderComponentData(toggleModals) {

    if (counterComponent && conversionsModalsComponent) {
        currentPlanInfo = await getCurrentPlanInfo();
        counterComponent.updateCounter(currentPlanInfo);
        if (toggleModals) {
            conversionsModalsComponent.toggleModals(currentPlanInfo, isLimit);

        }
    }

}

export async function renderCounterComponent() {
    await createCurrentPlanDataComponents();
    await rerenderComponentData();
}

export function onSuccessSignInOnConvert() {
    $('#signInModal').modal('hide');
    convertInProgress();
    convertFiles(inputtedFiles);
}

function reloadPage() {
    pendingPageRefreshAfterSuccessSignin = false; // not needed as we do refresh but put here to show the logic 
    setTimeout(() => location.reload(), 100);
}


function showSignInPopup(popupData, onSuccessFunc) {
    pendingPageRefreshAfterSuccessSignin = true;
    configureSignIn("#signInModal", popupData, onSuccessFunc);
    $('#signInModal').modal('show');
}

function configureSignIn(containerSelector, popupData, onSuccessFunc) {
    $(containerSelector + ' #errors-message').text("");
    $(containerSelector + ' .js-user-info-form').removeClass('was-validated');
    $(containerSelector + ' .js-user-info-form')[0].reset();

    $(containerSelector + ' #modal-title-1').text(popupData.ModalTitle1);
    $(containerSelector + ' #modal-title-2').text(popupData.ModalTitle2);

    $(containerSelector + ' #ok-button').text(popupData.OkButtonText);
    $(containerSelector + ' #ok-button-i').removeClass(); $(containerSelector + ' #ok-button-i').addClass(popupData.OkButtonIClass);

    $(containerSelector + ' #email-text-before-1').text(popupData.EmailTextBefore1);
    $(containerSelector + ' #email-text-before-2').text(popupData.EmailTextBefore2);
    $(containerSelector + ' #email-text-after-1').text(popupData.EmailTextAfter1);
    $(containerSelector + ' #email-text-after-2').text(popupData.EmailTextAfter2);

    $(containerSelector + ' .js-signin-button').off();
    $(containerSelector + ' .js-signin-button').on('click', () => okClickSingIn(containerSelector, onSuccessFunc));
}

function prepareConvertNewFiles() {
    inputtedFiles = '';
    $fileInput.val('');
    renderConvertNewSection();
}

function showInputedFiles(files) {

    let renderFiles;
    let temp;

    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        temp = `<li><i class="fa-solid fa-file-arrow-up"></i> ${file.name}</li>`;

        if (i === 0) {
            renderFiles = temp;
        } else {
            renderFiles += temp
        }

    }

    $inputtedFilesPlacement.html(renderFiles);

};

function hideInputedFiles() {
    $inputtedFilesPlacement.html('');
};

function clearInputtedFiles() {
    $convertButton.prop('disabled', true);
    inputtedFiles = '';
    $fileInput.val('');

    $inputtedFileWrapper.addClass('d-none');
    $('.decoration').removeClass('d-none');
};

function blockFileInput(clearFiles) {
    if (clearFiles) {
        clearInputtedFiles();
    }
    $fileInput.prop('disabled', true);
};

function unblockFileInput() {
    $fileInput.prop('disabled', false);
}

function inputAlertShow(key) {
    if (key) {
        $inputLimit.removeClass('d-none');
    } else {
        $inputLimit.addClass('d-none');
        $inputLimit.text('');
    }
}

function convertFiles(files) {
    if (!files) return;
    if (files.length > 0) {
        let formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
        }

        isLimit = false;

        converterResponse = $.ajax({
            url: "/api/FileConverter/ConvertFiles",
            data: formData,
            processData: false,
            contentType: false,
            xhrFields: {
                responseType: 'blob'
            },
            type: "POST",
            success: function (response) {
                renderDownloadSection();
                handleFileDownload(response);
                convertNotInProgress();
            },
            error: function (xhr, textStatus, errorThrown) {

                if (xhr.status === 403) {
                    const hasLicense = xhr.getResponseHeader('Has-License');
                    isLimit = true;
                    if (hasLicense === "false") {
                        undoConvertInProgress();
                        return;
                    }
                }

                if (xhr.status === 401) {
                    undoConvertInProgress();
                    showSignInPopup(signInPopupsData.signInOnConvert, onSuccessSignInOnConvert);
                } else {
                    renderErrorSection(); // when after success signin the error section's convert new will do a page reload  
                    convertNotInProgress();
                }

            },
            complete: async function () {
                await rerenderComponentData(true);
            }
        });
    }
}

function handleFileDownload(data) {
    if (!(data instanceof Blob)) {
        console.error('Invalid response type. Expected a Blob.');
        return;
    }

    let blob = new Blob([data], { type: data.type });
    let filename = "";

    let disposition = converterResponse.getResponseHeader('content-disposition');

    if (disposition && disposition.indexOf('attachment') !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
    }
    if (navigator.msSaveBlob) {
        // For Internet Explorer
        navigator.msSaveBlob(blob, filename);
    } else {
        // For other browsers
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

function convertInProgress() {
    $clearInputtedFilesBtn.addClass('d-none');
    $convertButton.prop('disabled', true);
    $('.convert-spinner').removeClass('d-none');
    $fileWrapper.addClass('convert-in-progress');
    $fileInput.prop('disabled', true);
}

function undoConvertInProgress() {
    $clearInputtedFilesBtn.removeClass('d-none');
    $convertButton.prop('disabled', false);
    $('.convert-spinner').addClass('d-none');
    $fileWrapper.removeClass('convert-in-progress');
    $fileInput.prop('disabled', false);
}

function convertNotInProgress() {
    $fileWrapper.removeClass('convert-in-progress');
    $('.convert-spinner').addClass('d-none');
    $inputtedFileWrapper.addClass('d-none');
    hideInputedFiles();
    $('.decoration').removeClass('d-none');
}

function renderDownloadSection() {
    blockFileInput(false);
    $fileWrapper.addClass('convert-succsessful');
    $('.description .message').text(`Download is started!`);
    $('.description .download').removeClass(`d-none`);
    $('.upload-icon').removeClass('fa-file-arrow-up fa-7x');
    $('.upload-icon').addClass('fa-circle-check fa-3x');

    $convertButton.addClass('d-none');
    $('.js-download-converted-files').removeClass('d-none');
    $('.js-convert-new-files').removeClass('d-none');

    $('.js-start-page').addClass('d-none');
    $('.js-final-page').removeClass('d-none');
}

function renderErrorSection() {
    blockFileInput(true);
    $fileWrapper.addClass('convert-error');
    $('.description .message').html(`Something went wrong<br>Please try again`);
    $('.upload-icon').removeClass('fa-file-arrow-up fa-7x');
    $('.upload-icon').addClass('fa-circle-exclamation fa-3x');
    $convertButton.addClass('d-none');
    $('.js-convert-new-files').removeClass('d-none');
}

function renderConvertNewSection() {
    unblockFileInput();
    $fileInput.prop('disabled', false);
    $fileWrapper.removeClass('convert-succsessful convert-error');
    $('.description span').text(`Select files`);
    $('.description .download').addClass(`d-none`);
    $('.upload-icon').removeClass('fa-circle-check fa-circle-exclamation fa-3x');
    $('.upload-icon').addClass('fa-file-arrow-up fa-7x');

    $('.js-download-converted-files').addClass('d-none');
    $('.js-convert-new-files').addClass('d-none');
    $convertButton.removeClass('d-none');

    $('.js-final-page').addClass('d-none');
    $('.js-start-page').removeClass('d-none');

}

function fetchSubscriptionInfo() {
    $.ajax({
        url: '/api/payment/SubscriptionInfo',
        method: 'GET',
        success: function (data) {
            $('.js-subscription-alert').addClass('d-none');
            $('.js-no-subscription-alert').addClass('d-none');
            $('.js-error-alert').addClass('d-none');

            if (data.error) {
                $('.js-error-alert').removeClass('d-none');
            } else if (data.hasLicense) {
                $('.js-subscription-start').text(formatDateForData(data.startDate));
                $('.js-subscription-end').text(formatDateForData(data.endDate));
                $('.js-subscription-alert').removeClass('d-none');
            } else {
                $('.js-no-subscription-alert').removeClass('d-none');
            }
        },
        error: function (jqXHR) {
            $('.js-subscription-alert').addClass('d-none');
            $('.js-no-subscription-alert').addClass('d-none');
            $('.js-error-alert').removeClass('d-none');

            console.error('Error fetching subscription info:', jqXHR.status, jqXHR.responseText);
        }
    });
}

if (window.location.href.includes('Manage/ChangePassword')) {
    fetchSubscriptionInfo();
}

async function getCurrentPlanInfo() {
    try {
        const info = await getRequest(CONSTANTS.API_URL_CURRENT_PLAN);
        return info;
    } catch (error) {
        console.error('Response failed:', error);
        return null;
    }
}

async function createCurrentPlanDataComponents() {

    if (!isUserLoggedIn) return;

    try {

        currentPlanInfo = await getCurrentPlanInfo();
        
        if (currentPlanInfo) {
            counterComponent = new CounterComponent(currentPlanInfo);

            conversionsModalsComponent = new ConversionsModalsComponent(currentPlanInfo);

            await Promise.all([
                counterComponent.initialize(),
                conversionsModalsComponent.initialize()
            ]);

            return Promise.resolve();
        }
    } catch (error) {
        console.error("Error initializing components:", error);
    }
}

function renderNavigationPane() {
    navigationPaneComponent = new NavigationPaneComponent();
    navigationPaneComponent.init();
}

//Trigger functions

renderCopyrightDate();
checkCookie();
renderNavigationPane();

if (isUserLoggedIn) {

    if (!counterComponent || !conversionsModalsComponent) {

        renderCounterComponent();
    }

}
export function rerenderMenu(partialContainerSelector, endpointUrl) {
    const menuContainer = document.querySelector(partialContainerSelector);

    if (!menuContainer) {
        console.error("Menu container not found:", partialContainerSelector);
        return;
    }

    fetch(endpointUrl, {
        method: "GET",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Failed to fetch menu: ${response.statusText}`);
            }
            return response.text();
        })
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newPartial = doc.querySelector(partialContainerSelector);

            if (newPartial) {
                menuContainer.innerHTML = newPartial.innerHTML;
            } else {
                console.warn("Partial container not found in response.");
            }
        })
        .catch((error) => {
            console.error("Error re-rendering menu:", error);
        });
}